import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PhoneInput from 'components/form/PhoneInput';

const Email = ({ question }) => {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <PhoneInput fullWidth placeholder="eg. 236-808-2584" />
    </Box>
  );
};

export default Email;
